import { useContext, useMemo } from 'react';
//
// import { AuthContext } from './JwtContext';
// import { AuthContext } from './Auth0Context';
import { AuthContext } from './FirebaseContext';
import { InstantiateUserFromJSON } from '../models/owner-portal/userAccountGeneral';
// import { AuthContext } from './AwsCognitoContext';

// ----------------------------------------------------------------------

export const useAuthContext = () => {
  const context = useContext(AuthContext);
  const userModel = useMemo(
    () => (context?.user ? InstantiateUserFromJSON(context.user) : null),
    [context]
  );

  if (!context) throw new Error('useAuthContext context must be use inside AuthProvider');

  return { ...context, user: userModel };
};
